import { IScope } from 'angular';
import {
    COUNTRIES,
    IDjangoApi1License,
    IOrder,
    OrderService,
    hasReplacedLicense,
    hasUpgradedOrRenewed,
    hasWebLicenseSelfHosted,
} from '../../tn.common';
import { hasWebFreeTrialLicense } from '../../tn.licenses/has-license-type.filter/has-web-free-trial-license';
import { LicenseService } from '../../tn.licenses/license.service/license-service';

export class OrderDetails {
    licenses = this.licenseService.get();
    filteredLicenses = this.licenseService.getFilteredLicenses();
    sortedLicenses: IDjangoApi1License[] = [];
    couponDiscount = parseFloat(this.order.coupon_discount) || 0;
    discount = this.order.bulk_discount;
    subTotal =
        parseFloat(this.order.subtotal) +
        parseFloat(this.order.upgrade_price_adjustment) -
        (this.discount + this.couponDiscount);
    hasWebLicenseSelfHosted = hasWebLicenseSelfHosted(this.order.licenses);
    hasWebLicenseFreeTrial = hasWebFreeTrialLicense(this.order.licenses);
    hasReplacedLicenses = hasReplacedLicense(this.order.licenses);
    hasUpgradedOrRenewed = hasUpgradedOrRenewed(this.order.licenses);

    static $inject = ['order', '$scope', 'tnLicenseService', 'orderService'];
    constructor(
        protected order: IOrder,
        $scope: IScope,
        protected licenseService: LicenseService,
        protected orderService: OrderService
    ) {
        this.licenseService.set(this.order.licenses);
        $scope.$watch(
            'vm.filteredLicenses',
            (newLicenses: IDjangoApi1License[]) => {
                this.sortedLicenses.splice(0, this.sortedLicenses.length);
                this.sortedLicenses.push(...newLicenses);
                this.sortedLicenses.sort((a, b) =>
                    licenseService.sortByName(a, b)
                );
            },
            true
        );
    }

    getTotalCost(l: IDjangoApi1License): number {
        return this.licenseService.getTotalCost(l);
    }

    getFullCountryName(abbreviation: string): string | null {
        const countryName = COUNTRIES.filter(
            (country) => country.value === abbreviation
        );
        if (
            typeof countryName === 'undefined' ||
            typeof countryName[0] === 'undefined'
        ) {
            return null;
        }
        return countryName[0].label;
    }
}
